import React, { ReactElement, useCallback, useState, useEffect } from "react"
import { Typography, Grid, Card, CardContent } from "@material-ui/core"
import { useMachine } from "@xstate/react"
import { PageContainer } from "../../components/Layouts"
import SectionTitle from "../../components/SectionTitle"
import fetchMachine from "../../components/Forms/CFC/__config/machine"
import useCurrentClient from "../../state/client/useCurrentClient"
import CFCUseCase from "../../data/CFC/CFCLogic"
import { CFCStruct, CFCId } from "../../data/_config/shape"
import CanvasList from "../../components/CFC/CanvasList"
import Loading from "../../components/Loading"
import NoCanvases from "../../components/CFC/NoCanvases"
import filterById from "../../util/filters/ById"
import { Link } from "react-router-dom"
import { PrivateRoutes, routeVarReplacement } from "../../util/routes/routes"

const CanvasListing = (): ReactElement => {
	const [stateMachine, changeState] = useMachine(fetchMachine)
	const [currentClient] = useCurrentClient()
	const [canvasData, setCanvasData] = useState<CFCStruct[]>([])
	const fetchData = useCallback(async () => {
		if (currentClient?.id) {
			try {
				const data = await CFCUseCase.findByClient(currentClient.id)
				if (data.length === 0) {
					changeState("REJECT")
					return
				}
				const newData = data.filter((item) => item.canvasType == "wizard")
				setCanvasData(newData)
				changeState("RESOLVE")
			} catch {
				changeState("REJECT")
			}
		}
	}, [currentClient, changeState])

	useEffect(() => {
		fetchData()
	}, [fetchData])

	async function removeCanvas(id: CFCId): Promise<void> {
		const newData = canvasData.filter(filterById(id, true))
		setCanvasData(newData)
		if (newData.length === 0) {
			changeState("REJECT")
		}
		await CFCUseCase.delete(id)
	}

	async function editCanvas(item: CFCStruct): Promise<void> {
		// const newData = canvasData.filter(filterById(item.id, true))
		// setCanvasData(newData)
		// if (newData.length === 0) {
		// 	changeState("REJECT")
		// }
		await CFCUseCase.update(item.id, item)
		window.location.reload()
	}

	function renderBasedOnState(): ReactElement {
		switch (stateMachine.value) {
			case "failure":
				return (
					<CardContent>
						<Typography variant="h6">Nema ni jednog Wizarda</Typography>
						<Typography>
							Proverite da li ste{" "}
							<Link to={PrivateRoutes.ClientList}>izabrali kompaniju</Link> ili{" "}
							<Link
								to={routeVarReplacement(PrivateRoutes.PlanningStep1, [
									[":id?", ""],
								])}
							>
								kreirajte novi Wizard
							</Link>
							.
						</Typography>
					</CardContent>
				)
			case "success":
				return (
					<CanvasList
						data={canvasData}
						remove={removeCanvas}
						edit={editCanvas}
						canvasType={"wizard"}
					/>
				)
			case "loading":
			default:
				return <Loading />
		}
	}

	return (
		<>
			<PageContainer role="main">
				<SectionTitle component="h1">
					Prethodno sačuvani Wizardi{" "}
					<Typography variant="subtitle1" component="p" color="textSecondary">
						Učitajte prethodni Wizard odabirom sa donje liste.
					</Typography>
				</SectionTitle>

				<Grid container spacing={2}>
					<Grid item xs={12} md={6}>
						<Card>{renderBasedOnState()}</Card>
					</Grid>
				</Grid>
			</PageContainer>
		</>
	)
}

export default CanvasListing
